import { AutogenLayoutStateList } from "./autogen/AutogenLayoutStateList";

export class StateList extends AutogenLayoutStateList {

    override onLoad() {
        this.mainDataSource.search();
    }
}
